import React from "react";

const Avatar = ({ image, name, size = 40 }) => {
  const firstLetter = name?.charAt(0)?.toUpperCase() || "U";

  if (image) {
    return (
      <img
        src={image}
        alt={name}
        style={{ width: size, height: size }}
        className="rounded-full object-cover"
      />
    );
  }

  return (
    <div
      style={{ width: size, height: size }}
      className="rounded-full bg-palatte flex items-center justify-center text-white font-bold"
    >
      {firstLetter}
    </div>
  );
};

export default Avatar;
